import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import type { ImportRunPaginatedRequest } from 'types'

import { importRunList, importRunsLatest } from './import-run.service'

export const importRunKeyFactory = {
  base: () => ['import-runs'],
  list: (request?: ImportRunPaginatedRequest) => [
    ...importRunKeyFactory.base(),
    'list',
    ...(request ? [request] : []),
  ],
  latest: () => [...importRunKeyFactory.base(), 'latest'],
}

export const queryImportRunList = (request: ImportRunPaginatedRequest) =>
  queryOptions({
    queryKey: importRunKeyFactory.list(request),
    queryFn: () => importRunList(request),
    placeholderData: keepPreviousData,
  })

export const queryImportRunsLatest = () =>
  queryOptions({
    queryKey: importRunKeyFactory.latest(),
    queryFn: () => importRunsLatest(),
    staleTime: 1000 * 60 * 15,
  })
